import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import PropTypes from "prop-types";

// CustomFileList sub-component is a simple list of files with download and remove buttons. It's customized and styling needs to be
// enhanced if you want to use it in a production environment.
const CustomFileList = ({ files, onDownload, onRemove }) => {
    return (
        <ul>
            {files.map((file) => (
                <li key={file.name} className="k-file k-file-progress">
                    <span className="k-icon k-font-icon k-i-file-word k-icon-xl"></span>
                    <span className="k-file-name">{file.name}</span>
                    <strong className="k-upload-status">
                        <Button
                            type="button"
                            icon="download"
                            title="Download"
                            look="flat"
                            onClick={ async (event) => await onDownload(file)}
                        />
                        <Button
                            type="button"
                            icon="close"
                            title="Remove"
                            look="flat"
                            onClick={ async (event) => await onRemove(file.uid)}
                        />
                    </strong>
                </li>
            ))}
        </ul>
    );
};

CustomFileList.propTypes = {
    files: PropTypes.array.isRequired,
    onDownload: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default CustomFileList;
